// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2kjq8","content":"styles_content__3zCMC","selectAll":"styles_selectAll__1Qodh"};